import api from 'api'
import { PayoutSummary } from './getUserPayments'

export type GetPayoutSummaryResponse = PayoutSummary

export const getPayoutSummary = async (
  paymentId: number
): Promise<GetPayoutSummaryResponse> => {
  const response = await api.get(`/admin/user_payments/${paymentId}/payout`)
  return {
    ...response.data,
    relatedPayments: response.data.relatedPayments ?? [],
    evereePaymentId: response.data.evereePaymentId ?? null,
    highnote: response.data.highnote
      ? {
          ...response.data.highnote,
          auditEvents: response.data.highnote.auditEvents ?? [],
        }
      : null,
  }
}
